// src/components/Tooltip.js
import React from "react";

const Tooltip = ({ text, children }) => {
  return (
    <div className="relative group inline-block">
      {children}
      <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 hidden group-hover:block whitespace-nowrap bg-gray-600 text-white text-xs rounded-md px-2 py-1 shadow-lg z-50">
        {text}
      </div>
    </div>
  );
};

export default Tooltip; // 👈 make sure it's default export
